export default __webpack_public_path__ + "static/media/THERMAL_FORMAT_3.1b0c9e1c.png";